'use strict';
/* global pageContext */

var dataLayer = window.dataLayer;

/**
 * @param {string} email - user's email submitted
 * @param {string} hashedEmail - user's email submitted in a hased form
 * @description pushes email to dataLayer during footer email submit
 */
function emailSubmit(email, hashedEmail) {
    var obj = {
        event: 'emailSubmit',
        email: email,
        hashedEmail: hashedEmail
    };

    dataLayer.push(obj);
}

/**
 * @param {Object} productObject The product data
 * @description gets the data for a product click
 */
function productClick(productObject) {
    var obj = {
        event: 'productClick',
        ecommerce: {
            click: {
                actionField: {
                    list: pageContext.type
                },
                products: []
            }
        }
    };

    obj.ecommerce.click.products.push(productObject);
    dataLayer.push(obj);
}

/**
 * @param {Object} productObject The product data
 * @description gets the data for a wishlist click
 */
function wishlistClick(productObject) {
    var obj = {
        event: 'wishlistClick',
        ecommerce: {
            click: {
                actionField: {
                    list: pageContext.type
                },
                products: []
            }
        }
    };

    obj.ecommerce.click.products.push(productObject);
    dataLayer.push(obj);
}

/**
 * @param {Object} productObject The product data
 * @description gets the data for product compare click
 */
function compareClick(productObject) {
    var obj = {
        event: 'compareClick',
        ecommerce: {
            click: {
                actionField: {
                    list: pageContext.type
                },
                products: []
            }
        }
    };

    obj.ecommerce.click.products.push(productObject);
    dataLayer.push(obj);
}

/**
 * @description Click event for add product to cart
 * @param {Object} productObject The product data
 * @param {string} quantity product quantity
 */
function addToCart(productObject, quantity) {
    var quantityObj = {
        quantity: quantity
    };
    var obj = {
        event: 'addToCart',
        currencyCode: 'USD',
        ecommerce: {
            add: {
                products: []
            }
        }
    };
    obj.ecommerce.add.products.push($.extend(productObject, quantityObj));
    dataLayer.push(obj);
}

/**
 *
 * @param {Object} productObject product object
 * @param {string|number} quantity product quantity
 */
function removeFromCart(productObject, quantity) {
    var quantityObj = {
        quantity: quantity
    };

    var obj = {
        event: 'removeFromCart',
        ecommerce: {
            remove: {
                products: []
            }
        }
    };

    obj.ecommerce.remove.products.push($.extend(productObject, quantityObj));
    dataLayer.push(obj);
}

/**
 * Updates the current step in the checkout flow
 * @param {Integer} step the step number the flow is currently on
 */
function updateCheckoutStep(step) {
    var gtmDataString = $('#checkout-main').attr('data-gtmdata');
    if (gtmDataString) {
        var gtmData = $.parseJSON(gtmDataString);
        if (!gtmData) {
            return;
        }
        if (gtmData.ecommerce.checkout.actionField.step === step) {
            return;
        }
        gtmData.ecommerce.checkout.actionField.step = step;
        dataLayer.push(gtmData);
    }
}

/**
 * @description Convenience method for creating a click event.
 * @param {string} event event
 * @param {string} eventCategory event categroy
 * @param {string} eventAction event action
 * @param {string} eventLabel event layer
 */
function pushEvent(event, eventCategory, eventAction, eventLabel) {
    dataLayer.push({
        event: event,
        eventCategory: eventCategory,
        eventAction: eventAction,
        eventLabel: eventLabel
    });
}

var events = {
    account: function () {},
    cart: function () {
        $('.cart.cart-page .remove-product').on('click', function () {
            var gtmData = $(this).attr('data-gtmdata');
            var qty = $(this).attr('data-quantity');
            $('.cart-delete-confirmation-btn').on('click', function () {
                removeFromCart($.parseJSON(gtmData), qty);
            });
        });
    },
    checkout: function () {
        $('body').on('gtm:shipping', function (e) {
            updateCheckoutStep(2);
        });

        $('body').on('gtm:billing', function (e, data) {
            updateCheckoutStep(3);
        });

        $('body').on('gtm:placeOrder', function () {
            updateCheckoutStep(4);
        });
    },
    compare: function () {
        $('.wishlistTile').on('click', function () {
            wishlistClick($.parseJSON($(this).attr('data-gtmdata')));
        });
    },
    product: function () {},
    search: function () {
        $('.quickview').on('click', function () {
            productClick($.parseJSON($(this).closest('.product-tile').find('[data-gtmdata]').attr('data-gtmdata')));
        });
        $('.wishlistTile').on('click', function () {
            wishlistClick($.parseJSON($(this).attr('data-gtmdata')));
        });
        $('.compare input[type=checkbox]').on('click', function () {
            var checked = $(this).is(':checked');
            if (checked) {
                compareClick($.parseJSON($(this).attr('data-gtmdata')));
            }
        });
    },
    storefront: function () {},
    wishlist: function () {},
    // events that should happen on every page
    all: function () {
        $('.pdp-link .link').on('click', function () {
            productClick($.parseJSON($(this).attr('data-gtmdata')));
        });
        $('.nav-link.dropdown-toggle').on('click', function () {
            pushEvent('trackEvent', 'User Action', 'Header Click', $(this).html());
        });
        $('.navbar-header.brand').on('click', function () {
            pushEvent('trackEvent', 'User Action', 'Header Click', 'Home Link');
        });

        $(document).on('click', '.minicart .remove-product', function () {
            var gtmData = $(this).attr('data-gtmdata');
            var qty = $(this).attr('data-quantity');
            $('.cart-delete-confirmation-btn').on('click', function () {
                removeFromCart($.parseJSON(gtmData), qty);
            });
        });
        $(document).on('click', '.add-to-cart-global,.add-to-cart', function () {
            var qty = $('.quantity-input').val() || 1;
            addToCart($.parseJSON($(this).attr('data-gtmdata')), qty);
        });

        $(document).on('email-sign-up', function (e, data) {
            emailSubmit(data.emailAddress, data.hashedEmail);
        });
    }
};


/**
 *
 * @description Initialize the tag manager functionality
 * @param {string} nameSpace The current name space
 */
exports.init = function (nameSpace) {
    var ns = nameSpace || pageContext.ns;
    if (ns && events[ns]) {
        events[ns]();
    }
    events.all();
};
